<template>
    <section id="brand-animation">
        <div class="row justify-content-between">
            <div class="col-12 col-lg-3">
                <h2 v-msh-html="brandAnimation.title" class="mt-lg-5" />
            </div>
            <div class="col-12 col-lg-9">
                <ul class="advantage-list row ps-0 ps-lg-3">
                    <li
                        v-for="(advantage, index) in brandAnimation.brandAdvantages"
                        :key="'adv-' + index"
                        class="col-12 col-md-6 mb-1 mb-md-2 px-1"
                    >
                        <div class="advantage-item h-100 bg-white p-2">
                            <div class="mb-1 d-flex justify-content-center d-webview-none">
                                <span class="advantage-icon text-primary" :class="[advantage.icon]" aria-hidden="true" />
                            </div>
                            <div class="mt-md-0 mb-md-2">
                                <h3 v-msh-html="advantage.title" class="h4 py-0" />
                                <p v-msh-html="advantage.text" class="text-gray3 mb-0 py-0" />
                            </div>
                        </div>
                    </li>
                    <li
                        class="col-12 px-1 mb-2"
                    >
                        <div class="d-lg-none advantage-item h-100 bg-white p-2">
                            <div class="mb-1 d-flex justify-content-center d-webview-none">
                                <img
                                    class="advantages-picto d-lg-flex"
                                    loading="lazy"
                                    alt=""
                                    :src="brandAnimation.reloadMarquePicto"
                                >
                            </div>
                            <div class="mt-md-0 mb-md-2">
                                <h3 v-msh-html="brandAnimation.reloadMarqueTitle" class="h4 py-0" />
                                <p v-msh-html="brandAnimation.reloadMarqueText" class="text-gray3 mb-0 py-0" />
                            </div>
                        </div>

                        <div class="d-none d-lg-block bg-white advantage-item">
                            <div class="ps-5">
                                <img
                                    class="advantages-image d-lg-flex"
                                    loading="lazy"
                                    alt=""
                                    :src="brandAnimation.image"
                                >
                            </div>
                        </div>
                        <div class="d-none d-lg-block advantages-reload position-absolute bg-white">
                            <div class="mb-1 d-flex justify-content-start d-webview-none">
                                <img
                                    class="advantages-picto d-lg-flex"
                                    loading="lazy"
                                    alt=""
                                    :src="brandAnimation.reloadMarquePicto"
                                >
                            </div>
                            <div class="mt-md-0 mb-md-2">
                                <h3 v-msh-html="brandAnimation.reloadMarqueTitle" class="h4 py-0" />
                                <p v-msh-html="brandAnimation.reloadMarqueText" class="text-gray3 mb-0 py-0" />
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </section>
</template>
<script>

export default {
    name: "BrandAnimationSectionCds",
    components: {},
    props: {
        brandAnimation: {
            type: Object,
            required: true
        }
    }
}
</script>
<style scoped lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.advantages-picto {
    width: px-to-rem(89);
}

.advantages-image {
    height: px-to-rem(300);
    padding-left: px-to-rem(282);
}

.advantages-reload {
    width: px-to-rem(314);
    bottom: 5%;
    left: 34%;
}

ul.advantage-list li {
    list-style: none;
}

.advantage-item {
    --corner: 3em;
    clip-path: polygon( var(--corner) 0, calc(100% - var(--corner)) 0, 100% 0, 100% 100%, 0% 100%, 0 var(--corner) );
    text-decoration: none;

    .advantage-icon {
        text-align: center;
        font-size: px-to-rem(54);
        font-weight: 400;
    }
}
</style>
